import { ImportableItem } from '../../../../../lib/imports/importTypes';

export interface RedistributionImportInputData extends ImportableItem {
  sourceStoreIdentifier: string;
  targetStoreIdentifier: string;
  productIdentifier: string;
  count?: number;
  description?: string;
}
export enum InstructionType {
  QUANTITY = 'Quantity',
  DESCRIPTION = 'Description',
  QUANTITY_DESCRIPTION = 'QuantityWithDescription',
}

export enum ProcessingStep {
  IMPORT = 0,
  VALIDATION = 1,
  FINALIZED = 2,
}
